import { useMutation } from "@apollo/client/react";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import { UPDATE_INVOICE_SERVICE_TYPE } from "../../mutations/invoices/updateInvoiceServiceType";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useUpdateInvoiceServiceType = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [updateInvoiceServiceType, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_SERVICE_TYPE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [
            GET_INVOICE_LATEST_VALIDATION_RESULT,
            GET_CLIENT_ASSESSMENT_INVOICES,
            GET_INVOICE_ASSESSMENT_DETAILS,
          ],
      awaitRefetchQueries: true,
    },
  );

  return { updateInvoiceServiceType, data, loading, error };
};
